import { useEffect } from 'react'
import { useLocation } from 'react-router'

export function PageViewTracker () {
  const location = useLocation()

  useEffect(() => {
    window.segment?.page('', 'app_frontend_page')
  }, [location])

  return null
}
